import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastModule} from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { Meta } from '@angular/platform-browser';
import { environment } from '../../src/environments/environment';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import { TextContrastService } from './_services/text-contrast.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    NgxSpinnerModule,
    ToastModule,
    RouterModule,
    TranslateModule
  ],
  providers: [ 
    {provide: DateAdapter, useClass: NativeDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS},
    MessageService,
 ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})

export class AppComponent implements OnInit {
  title = 'WannabookPublic';
  linkid = "";
  qTitle = "";

  constructor(private dateAdapter: DateAdapter<Date>, 
    private meta: Meta, 
    private route: ActivatedRoute,  
    private router: Router,
    private translate: TranslateService,
    textContrast: TextContrastService) {
    // Keeps text readable on every screen whatever colours the venue has chosen -
    // no more white text on white boxes. See text-contrast.service.ts.
    textContrast.start();

    // Language setup lives in the app initializer in app.config.ts, not here, so the
    // translation file is loaded before any component - this one included - is built.
    this.dateAdapter.setLocale('en-GB');

    //delete all the local storage variables first
    localStorage.removeItem("SmartVenueName");
    localStorage.removeItem("SmartVenueID");
    localStorage.removeItem("VenueSettingsID");
    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    localStorage.removeItem("EventBookingPassed");
    localStorage.removeItem("EventBookingSelectedTime");
    localStorage.removeItem("EventBookingSelectedDate");
    localStorage.removeItem("EventBookingSelectedPackage");
    localStorage.removeItem("EventBookingSelectedAdmissions");
    localStorage.removeItem("EventBookingCustomerSelectedResources");
    localStorage.removeItem("MinimalDetails");
    localStorage.removeItem("PublicImgURL");
    localStorage.removeItem("PublicImageheight");
    localStorage.removeItem("PublicImageWidth");
    localStorage.removeItem("DefaultColour");
    localStorage.removeItem("EMailSMSConfirmation");
    localStorage.removeItem("GoogleTagManagerID");
    localStorage.removeItem("RyftSubAccountID");
    localStorage.removeItem("returnPage");

    // this.route.queryParamMap.subscribe(params => {
    //  const lid = params.get('linkdata') || '';

    //  this.router.navigateByUrl("/booking/littlebrownmouse?LinkId=" + lid);
    //});


      //this.router.navigateByUrl("/booking/littlebrownmouse/linkid=" +  this.linkid);

    //if (environment.production) {
      //LogRocket.init('zslez2/wannabook');
    //}
  }

  ngOnInit(): void {

  }

    //   let splitlink: string[] = linkdata.split("!!!");
      
    //   if( splitlink[0] != null && splitlink[0] != "" )
    //     this.meta.updateTag({property: 'og:title', content: splitlink[0]});    

    //   if( splitlink[1] != null && splitlink[1] != "" )
    //     this.meta.updateTag({property: 'og:description', content:  splitlink[1]});

    //   if( splitlink[2] != null && splitlink[2] != "" )
    //     this.meta.updateTag({property: 'og:image', content:  splitlink[2]});    

    //   if( splitlink[3] != null && splitlink[3] != "" )
    //     this.meta.updateTag({property: 'og:url', content: splitlink[3]});
    // }


  //}

}
